module.exports = __webpack_public_path__ + "static/img/charm_level_97.93232ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/charm_level_97.png
// module id = We6p
// module chunks = 0